import React, { useState, useEffect } from "react";
import "./Participant.scss";
import Button from "../Button/Button";
import { prop } from "cheerio/lib/api/attributes";

function Participant(props) {
    console.log('Participant: ', props)
    return (
        <div onClick={props.onClick} className={`Participant ${props.active === "deactive" && "deactivated"}`}>
            
            <div className={`person ${props.isYou && 'you'} ${props.size}`}>
                {!props.isYou ?
                <img src={props.image || props.teamMember.icon} alt='' />
                :
                <img src={'media/img/icons/user-shape.svg'} alt='' />
                }
            </div>
            
            {(props.dialogue != null && props.dialogue !== "") &&
                <img className="dialogueIcon" src="media/img/dialogue_icon.png" 
                alt="" />}
            
            {(props.hasVisited && !props.visited) && 
                <img 
                    className={`chatIconEmpty ${props.size}`} 
                    src="media/img/chat_icon_empty.png" alt='' />}
            
            {(props.scale > 0 && props.scale < 6) &&
                <img 
                    className={`reaction ${props.size}`} 
                    src={`media/img/icons/testPointScale/${props.scale}-scale.png`} 
                    alt='' />}
            
            {(props.hasNameTag && props.teamMember) && 
                <div className={`name-tag ${props.size}`}>
                    {/* First Name, Last Name */}
                    <p className={'tag-name'}>
                        {!props.isYou &&`${props.teamMember.first} ${props.teamMember.last}`}
                        {props.isYou && `You`}
                    </p>
                    {/* Title */}
                    <div className={'tag-subtitles'}>
                        <p className={'tag-title'}>
                            {props.title || props.teamMember.title},
                        </p>
                        <p className={`tag-team`}>
                            {props.teamMember.teamName}
                        </p>
                    </div>
                </div>}
        </div>
    )
}

export default Participant